import type { Confidence } from "../homepage/insights-homepage.types"
import type { ActionRow } from "./actions.types"

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents -- "ALL" retained for readability/self-documentation even though it's a `string` subset.
export type DetectorFilter = "ALL" | string
export type ConfidenceFilter = "ALL" | Confidence

/**
 * Client-side AND filter over the action rows. "ALL" is a passthrough for the
 * detector/confidence facets; `minDollars` drops rows whose observed impact is
 * below the threshold (noise floor) — 0 keeps everything.
 */
export const filterActionRows = (
  rows: readonly ActionRow[],
  detector: DetectorFilter,
  confidence: ConfidenceFilter,
  minDollars = 0
): ActionRow[] =>
  rows.filter(
    (r) =>
      (detector === "ALL" || r.detector_code === detector) &&
      (confidence === "ALL" || r.confidence === confidence) &&
      r.impact_dollars >= minDollars
  )

/** Humanize a PascalCase detector label, e.g. "ScheduleMisalignment" -> "Schedule Misalignment". */
export const humanizeDetector = (label: string): string =>
  label.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
